(() => {
  const initCartAttributesHandlers = () => {
    const cartNote = document.querySelector(".cart__widget textarea#note");
    const cartGiftNote = document.querySelector(
      ".cart__widget textarea#gift-note"
    );

    console.log("first", cartNote, cartGiftNote);
    if (cartNote) {
      console.log(cartNote);
      cartNote.addEventListener("change", (e) => {
        console.log("asd");
        updateCartAttributes("note", e.target.value);
      });
    }

    if (cartGiftNote) {
      cartGiftNote.addEventListener("change", (e) => {
        updateCartAttributes("gift_note", e.target.value);
      });
    }
  };

  const updateCartAttributes = (key, value) => {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          [key]: value,
        },
      }),
    });
  };

  document.addEventListener("theme:cart:open", initCartAttributesHandlers);
  document.addEventListener("DOMContentLoaded", initCartAttributesHandlers);
})();
